import React from 'react';

const money = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return '0.00';
  return num.toFixed(2);
};

const addonTotal = (addon) => {
  if (addon?.total_addon_price != null && addon.total_addon_price !== '') {
    return Number(addon.total_addon_price);
  }
  const price = Number(addon?.addon_price || 0);
  const qty = Math.max(1, Number(addon?.quantity) || 1);
  return price * qty;
};

const ServicePackageDetails = ({ service, packageData, addons = [] }) => {
  const addonRows = (Array.isArray(addons) ? addons : []).filter(
    (addon) => addon && (addon.addon_name || addon.name)
  );
  if (!service && !packageData && addonRows.length === 0) return null;

  return (
    <section className="rounded-lg border border-gray-200 bg-surface p-5 sm:p-6 shadow-sm">
      <div className="mb-5">
        <h2 className="text-base font-bold text-gray-900">Service & package</h2>
        <p className="text-sm text-gray-500 mt-0.5">What the client booked</p>
      </div>

      {service ? (
        <div className={packageData || addonRows.length > 0 ? 'mb-5 pb-5 border-b border-gray-100' : ''}>
          <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500 mb-1">
            Service
          </p>
          <p className="text-sm sm:text-base font-semibold text-gray-900 break-words">
            {service.service_name}
          </p>
          {service.service_category?.category_name ? (
            <p className="text-sm text-gray-500 mt-1">{service.service_category.category_name}</p>
          ) : null}
        </div>
      ) : null}

      {packageData ? (
        <div className={addonRows.length > 0 ? 'mb-5 pb-5 border-b border-gray-100' : ''}>
          <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500 mb-1">
            Package
          </p>
          <p className="text-sm sm:text-base font-semibold text-gray-900 break-words">
            {packageData.package_name}
          </p>
          {packageData.description ? (
            <p className="mt-2 text-sm text-gray-600 leading-relaxed break-words">
              {packageData.description}
            </p>
          ) : null}
        </div>
      ) : null}

      {addonRows.length > 0 ? (
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500 mb-2">
            Add-ons
          </p>
          <ul className="space-y-2.5">
            {addonRows.map((addon) => {
              const name = addon.addon_name || addon.name;
              const qty = Math.max(1, Number(addon.quantity) || 1);
              return (
                <li key={addon.id || name} className="flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <p className="text-sm font-semibold text-gray-900 break-words">{name}</p>
                    {addon.addon_description ? (
                      <p className="mt-0.5 text-sm text-gray-600 break-words">
                        {addon.addon_description}
                      </p>
                    ) : null}
                    {qty > 1 ? (
                      <p className="mt-0.5 text-xs text-gray-500">Qty {qty}</p>
                    ) : null}
                  </div>
                  <p className="shrink-0 text-sm font-semibold tabular-nums text-gray-900">
                    ${money(addonTotal(addon))}
                  </p>
                </li>
              );
            })}
          </ul>
        </div>
      ) : null}
    </section>
  );
};

export default ServicePackageDetails;
